import { SVGProps } from "react";

export const BoyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={24}
    viewBox="0 0 13 24"
    fill="none"
    {...props}
  >
    <path
      fill="#61A5F5"
      d="M11.802 11.29c-.62-1.119-1.38-2.025-2.143-2.656a5.338 5.338 0 0 1-3.156 1.042 5.34 5.34 0 0 1-3.158-1.042c-.763.632-1.524 1.538-2.146 2.655-1.447 2.593-1.607 5.254-.356 5.945.56.31 1.145.079 1.751-.502-.113.626-.17 1.26-.169 1.896 0 2.968 1.16 5.372 2.586 5.372.86 0 1.287-.876 1.491-2.217C6.705 23.124 7.132 24 7.99 24c1.43 0 2.588-2.404 2.588-5.372 0-.668-.061-1.306-.171-1.896.607.58 1.193.813 1.753.502 1.249-.69 1.088-3.35-.359-5.946l.002.002Zm-5.3-2.625a4.37 4.37 0 0 0 3.077-1.27 4.33 4.33 0 0 0 1.274-3.064 4.316 4.316 0 0 0-1.276-3.063A4.354 4.354 0 0 0 6.5 0a4.37 4.37 0 0 0-3.077 1.27 4.323 4.323 0 0 0 .002 6.128 4.363 4.363 0 0 0 3.078 1.268Z"
    />
  </svg>
);
